// Import FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faHome,
	faTimes,
	faChartPie,
	faPencilAlt
} from '@fortawesome/free-solid-svg-icons'

// Configure Font-Awesome
library.add(faHome)
library.add(faTimes)
library.add(faChartPie)
library.add(faPencilAlt)
